import { createFileRoute } from '@tanstack/react-router';

import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout')({
  loader: async ({ params: { bookId, citationId }, context: { queryClient } }) => {
    const citation = await queryClient.ensureQueryData(getCitationOptions(bookId, citationId));

    return {
      citation,
      crumb: citation.title,
    };
  },
});
